import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  ListItem} from '@material-ui/core';
import SlidingPanel from 'react-sliding-side-panel';
import moment from 'moment';
import { removeDuplicates } from '../../utils/helper';
import { isBrowser } from 'react-device-detect';
import _ from 'lodash';
// import { IoMdCloseCircleOutline } from 'react-icons/io';

export default class AdvancedFilter extends Component {
  constructor (props) {
    super(props);
    this.state = {
      endDate: moment().startOf('month').format('L'),
      // moment(localStorage.getItem('selectedendDate'))
      //   .endOf('month')
      //   .format('L'),
      startDate: moment().endOf('month').format('L'),
      // moment(localStorage.getItem('selectedendDate'))
      //   .startOf('month')
      //   .format('L'),
      typeOfDate: localStorage.getItem('DateRadioSelect'),
      RadioSelect: localStorage.getItem('DateRadioSelect'),
      selectedMenu: {},
      configuration: this.props.filterConfig || {},
      disableSummaryRowCheckbox: false
    };
  }

  static propTypes = {
    advanceFilterConfig: PropTypes.object,
    prop: PropTypes,
    openSlidingPanel: false,
    handelDateChangesSlideDate: PropTypes.func,
    // leftTextArea: [],
    handleRightArrow: PropTypes.func,
    handleDoubleRight: PropTypes.func,
    handleDoubleLeft: PropTypes.func,
    handleLeftArrow: PropTypes.func,
    // rightTextArea: [],
    advancedFilter: {
      checkedA: false,
      checkedB: false,
      checkedC: false
    },
    handleCheckChange: PropTypes.func,
    handleClose: PropTypes.func
  };

  handelDateChangesSlideDate = (start, end, typeOfDate, RadioSelect) => {
    const { configuration } = this.state;
    configuration.startDate = start;
    configuration.endDate = end;
    configuration.typeOfDate = typeOfDate;
    configuration.RadioSelect = typeOfDate;
    // configuration.RadioSelect = localStorage.getItem('DateRadioSelect');
    this.setState({
      startDate: start,
      endDate: end,
      typeOfDate: typeOfDate,
      RadioSelect: RadioSelect,
      configuration
    });
  };

  handleGroupingChanges = (dir) => {
    const { configuration, selectedMenu } = this.state;
    if (selectedMenu?.key !== undefined) {
      if (dir === 'Left' || dir === 'Right') {
        configuration.groupBy.masterData = ((configuration.groupBy || {})
          .masterData || []).filter(x => x.value !== selectedMenu.value);
        configuration.groupBy.selected = ((configuration.groupBy || {})
          .selected || []).filter(x => x.value !== selectedMenu.value);
        if (dir === 'Right') {
          configuration.groupBy.selected.push(selectedMenu);
        } else {
          configuration.groupBy.masterData.push(selectedMenu);
          configuration.groupBy.masterData = _.orderBy(configuration.groupBy.masterData, ['order'], ['asc']);
        }
      }
    }
    if (dir === 'AllLeft') {
      configuration.groupBy.masterData = removeDuplicates([...((configuration.groupBy || {})
        .masterData || []), ...((configuration.groupBy || {})
        .selected || [])], 'key');
      configuration.groupBy.masterData = _.orderBy(configuration.groupBy.masterData, ['order'], ['asc']);

      configuration.groupBy.selected = [];
    }
    if (dir === 'AllRight') {
      configuration.groupBy.selected = removeDuplicates([...((configuration.groupBy || {})
        .selected || []), ...((configuration.groupBy || {})
        .masterData || [])], 'key');
      configuration.groupBy.masterData = [];
    }

    this.setState({
      // configuration
      disableSummaryRowCheckbox: configuration.groupBy.selected?.length === 0,
      configuration: {
        ...this.state.configuration,
        summaryRows: configuration.groupBy.selected?.length === 0 ? false : this.state.configuration.summaryRows,
        suppressDetails: configuration.groupBy.selected?.length === 0 ? false : this.state.configuration.suppressDetails
      }
    });
  }

  handleCheckChange = (e) => {
    if (!e.target.checked && e.target.name === 'summaryRows') {
      this.setState({
        configuration: {
          ...this.state.configuration,
          [e.target.name]: e.target.checked,
          suppressDetails: e.target.checked
        }
      });
    } else {
      this.setState({
        configuration: {
          ...this.state.configuration,
          [e.target.name]: e.target.checked
        }
      });
    }
  };

  render () {
    return (
      <div className='advanced-filters'>
        <SlidingPanel
          type={'right'}
          isOpen={this.props.openSlidingPanel}
          size={(isBrowser ? 31 : 36)}
        >
          <div className="rpt-container">
            <div className="header1 row">
              {' '}
              <div className="col-xs-11">Advanced Filters</div>
              <div className="col-xs-1 center-xs">
                {/* {' '}
                <Tooltip title="Close">
                  <IconButton
                    aria-label={'CloseIconAddWidgetPanel'}
                    size="small"
                    onClick={this.handleClose}
                  >
                    <IoMdCloseCircleOutline fontSize="small" size="small" />
                  </IconButton>
                </Tooltip> */}
              </div>
            </div>
            <div className="row widget-content">
              <div className="widget-holder col-lg-11 end-lg">
                <div className="row col-lg-12" style={{ display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                  {/* <h3 style={{ textAlign: 'left' }}>Pay Period</h3>
                  <div className="pay-periodtwo" style={{ alignSelf: 'center' }}>
                    <div className='slide_dateppicker'>
                      <SliderDatePicker
                        payPeriodStartDate={this.props.payPeriodStartDate}
                        payPeriodEndDate={this.props.payPeriodEndDate}
                        handelDateChangesSlideDate={
                          this.handelDateChangesSlideDate
                        }
                      />
                      <hr className="horizontal__line" />
                    </div>
                  </div> */}
                  <div className='group_all'>
                    <div className="group__title">
                      <h3>Groupings</h3>
                      {/* <div className='sub-heading'>
                          <h4 style={{ marginRight: '70px' }}>Available</h4>
                          <h4>Applied</h4>
                        </div> */}
                    </div>
                    <div className="text__area">
                      <div className="box__shadow_parent">
                        <h4>Available</h4>
                        <div className="box__shadow">
                          {this.state.configuration.groupBy.masterData.filter(y => y.value !== undefined).map((x, i) => (
                            <ListItem key={i}
                              button
                              selected={x.value === this.state.selectedMenu.value}
                              onClick={() => this.setState({ selectedMenu: x })}
                            >{x.key}</ListItem>
                          ))}
                        </div>
                      </div>

                      <div className="arrow__buttons_parent">
                        <div className="arrow__buttons">
                          <button
                            className="arrow__button"
                            onClick={() => { this.handleGroupingChanges('Right'); }}
                          >
                            {'>'}
                          </button>
                          <button
                            className="arrow__button"
                            onClick={() => { this.handleGroupingChanges('AllRight'); }}
                          >
                            {'>>'}
                          </button>
                          <button
                            className="arrow__button"
                            onClick={() => { this.handleGroupingChanges('AllLeft'); }}
                          >
                            {'<<'}
                          </button>
                          <button
                            className="arrow__button"
                            onClick={() => { this.handleGroupingChanges('Left'); }}
                          >
                            {'<'}
                          </button>
                        </div>
                      </div>

                      <div className="box__shadow_parent">
                        <h4>Applied</h4>
                        <div className="box__shadow">
                          {this.state.configuration.groupBy.selected.filter(y => y.value !== undefined).map((x, i) => (
                            <ListItem
                              key={i}
                              button
                              selected={x.value === this.state.selectedMenu.value}
                              onClick={() => this.setState({ selectedMenu: x })}
                            >{x.key}</ListItem>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div>
                      {this.state.configuration.showZeroNGraph && (<>
                        <div className='advance-checkBox'>
                          <FormGroup row>
                            {/* <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.configuration.suppressGraph}
                                  onChange={this.handleCheckChange}
                                  name="suppressGraph"
                                  color="primary"
                                />
                              }
                              label="Suppress Graph"
                            /> */}
                          </FormGroup>
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.configuration.suppressZero}
                                  onChange={this.handleCheckChange}
                                  name="suppressZero"
                                  color="primary"
                                />
                              }
                              label="Suppress Zero"
                            />
                          </FormGroup>
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  disabled={this.state.disableSummaryRowCheckbox}
                                  checked={this.state.configuration.summaryRows}
                                  onChange={this.handleCheckChange}
                                  name="summaryRows"
                                  color="primary"
                                />
                              }
                              label="Summary Rows"
                            />
                          </FormGroup>
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  disabled={!this.state.configuration.summaryRows}
                                  checked={this.state.configuration.suppressDetails}
                                  onChange={this.handleCheckChange}
                                  name="suppressDetails"
                                  color="primary"
                                />
                              }
                              label="Suppress Details"
                            />
                          </FormGroup>
                        </div>
                      </>)}
                    </div>
                  </div>

                  <Grid
                    container
                    justify="center"
                    className="advanced__buttons"
                    style={{ marginTop: '1em' }}
                  >
                    <div style={{ display: 'flex' }}>
                      <Button color="primary" onClick={this.props.handleClose}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => { this.props.onApplyFilter(this.state.configuration); }}
                        color="primary"
                      >
                        Apply
                      </Button>
                    </div>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </SlidingPanel>
      </div>
    );
  }
}
